import { createAction } from "@reduxjs/toolkit";

export const markPatientPrescriptionsPharmacistSigned = createAction(
	"dispense/markPatientPrescriptionsPharmacistSigned",
);

const RX_COLLECTION_KEYS = [
	"patients_win_rx_data",
	"patients_win_rx_data_delivered",
	"patients_win_rx_data_today_missed",
	"patients_win_rx_data_final_missed",
	"active_rx_data",
	"rx_data",
];

const patchRxRows = (rows, signedIds, signaturePayload) => {
	if (!Array.isArray(rows)) return rows;

	return rows.map((rx) => {
		const rxId = rx?.id ?? rx?.winrx_data_id;
		if (!signedIds.has(String(rxId))) return rx;

		return {
			...rx,
			f_sign_pharmasist_id: signaturePayload.f_sign_pharmasist_id,
			f_pharmasist_sign_name: signaturePayload.f_pharmasist_sign_name,
		};
	});
};

const patchPatient = (patient, patientId, signedIds, signaturePayload) => {
	if (!patient || typeof patient !== "object") return patient;

	const currentPatientId = patient?.id ?? patient?.patient_id;
	if (Number(currentPatientId) !== Number(patientId)) return patient;

	let patchedPatient = patient;

	RX_COLLECTION_KEYS.forEach((key) => {
		if (!Array.isArray(patchedPatient?.[key])) return;

		patchedPatient = {
			...patchedPatient,
			[key]: patchRxRows(patchedPatient[key], signedIds, signaturePayload),
		};
	});

	return patchedPatient;
};

const patchPatientsInContainer = (container, patientId, signedIds, signaturePayload) => {
	if (!container) return container;

	if (Array.isArray(container)) {
		return container.map((patient) =>
			patchPatient(patient, patientId, signedIds, signaturePayload),
		);
	}

	if (typeof container !== "object") return container;

	let patchedContainer = patchPatient(container, patientId, signedIds, signaturePayload);

	["data", "patient", "patients"].forEach((key) => {
		if (patchedContainer?.[key] == null) return;

		patchedContainer = {
			...patchedContainer,
			[key]: patchPatientsInContainer(
				patchedContainer[key],
				patientId,
				signedIds,
				signaturePayload,
			),
		};
	});

	return patchedContainer;
};

export const patchPatientPrescriptionsPharmacistSignedState = (state, payload = {}) => {
	const {
		patient_id,
		signed_prescription_ids = [],
		f_sign_pharmasist_id,
		f_pharmasist_sign_name,
		pharmacist_id,
		signature_img,
	} = payload;

	const signedIds = new Set(signed_prescription_ids.map((id) => String(id)));
	if (!patient_id || signedIds.size === 0) return;

	const signaturePayload = {
		f_sign_pharmasist_id: f_sign_pharmasist_id ?? pharmacist_id,
		f_pharmasist_sign_name: f_pharmasist_sign_name ?? signature_img,
	};

	if (!signaturePayload.f_sign_pharmasist_id || !signaturePayload.f_pharmasist_sign_name) {
		return;
	}

	state.data = patchPatientsInContainer(
		state.data,
		patient_id,
		signedIds,
		signaturePayload,
	);
};

